import { FetchStatusSelector } from "@obg/ngrx-utils";
import { CoreState } from "@obg/ngx.core";

import { LoginFeatureState } from "../state";

import { ACTION_PREFIX } from "./suspicious-login.action";
import { ChallengeDetails } from "./suspicious-login.model";

export namespace SuspiciousLoginSelector {
	export const isPinSent = (state: LoginFeatureState): boolean | undefined =>
		state.loginFeature?.suspiciousLogin.isPinSent;
	export const isBusy = (state: CoreState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	export const getChallengeDetails = (state: LoginFeatureState): ChallengeDetails | undefined =>
		state.loginFeature?.suspiciousLogin.challengeDetails;
}
